module.exports = __webpack_public_path__ + "static/media/UNKNOWN_WITH_DOGS.18a68f9a.svg";